import Fragment from 'delv/Fragment.js'

export default new Fragment(`id
name
locked
active`)
